export const defaultStrings = {
  level: 'medium',
  continue: 'Continue',
};
